module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-case"
  }, [_c('img', {
    staticClass: "top-img",
    attrs: {
      "src": require("assets/case/06/img1.png")
    }
  }), _vm._m(0), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollTop),
      expression: "scrollTop"
    }],
    staticClass: "scroll-top-btn",
    attrs: {
      "src": require("assets/goTop.png")
    },
    on: {
      "click": _vm.backtop
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "case-num"
  }, [_vm._v("Vol.06")]), _c('div', {
    staticClass: "case-title"
  }, [_vm._v("设计师爆改上海50㎡老房，示范小户型改造神操作")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("50㎡的房子可以玩出啥花样？窝仔的设计师朋友周琴，居然打造出客厅、卧室、厨房、餐厅、阳台、书房、储物区7大功能区，而且几乎任何边角位置都被充分利用，简直堪比大户型！")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/06/img2.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("「背景信息」")]), _c('div', {
    staticClass: "line1"
  }, [_c('span', [_vm._v("关于屋主")]), _vm._v("设计师周琴，知性女汉子一枚。从业近10年，帮无数业主实现过家的样子，在设计自住房的时候，自然要好好玩上一把。一个手枪型、只有50㎡的上海老房，让她充分挑战了设计极限。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("「房子的基本信息」")]), _c('div', {
    staticClass: "line1"
  }, [_c('span', [_vm._v("坐标：上海普陀")]), _vm._v(" "), _c('span', [_vm._v("户型：两室两厅")]), _vm._v(" "), _c('span', [_vm._v("使用面积：49㎡")]), _vm._v(" "), _c('span', [_vm._v("原始状态：80年代老房")]), _vm._v(" "), _c('span', [_vm._v("装修风格：现代轻奢")])]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/06/img3.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("原始房型图长得像一把手枪，很多建于70、80年代的上海老房都有这个特点——没有厅。拿到房子以后，周琴首先想到就是按功能需求重新做空间划分。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("客厅 15.5㎡：将卧室一分为二变出厅")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("北卧室和南卧室是连一长条的，原本的想法是把中间的墙拿掉，让客厅更大些，敲墙的时候发现是混凝土，就放弃了。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/06/img4.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("所以现在看到的客厅，是从原来的卧室一分为二改造出来的，中间采用三联动移门＋窗帘作为隔断。白天可以将窗帘拉开，这样光可以透进来。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/06/img5.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("电视墙一侧之前是通往餐厅的门洞，砌高60公分，让电视墙有了延伸，看起来客厅好像更大了。同时坐在客厅可透过门洞望向餐厅，两个空间有了联动，视觉上也更通透。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/06/img6.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("小户型整体硬装比较简单，主要采用大量软装进行装饰。整体的风格复古、轻奢、有质感，墙上的画组合摆放，看似毫无章法又很和谐。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/06/img7.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("复古绿沙发、实木电视柜和边柜，都是外形简洁、相对细腿儿的款，可以让空间看起来更大。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/06/img8.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("卧室 8㎡：无靠背床节省空间")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("从客厅延续到卧室的咖色硅藻泥墙，主要为了满足卧室的无靠背床。用硅藻泥做床头，相对涂料来说没那么脆弱，质感更好。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/06/img9.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("中间拉上一条金色不锈钢U型槽，像精致的腰封。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("小窍门：施工顺序是先做墙面涂料，后做金线条，最后做硅藻泥。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/06/img10.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("为了节省空间，床两侧没有设置常规的床头柜，而是摆了两张非常简单的角几，用来随手放东西。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/06/img11.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("正对床是一面顶天立地的衣柜，门采用的是模压板材质，黑色长拉手，这样的处理可以弱化它在空间的存在感，看起来非常简约。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/06/img12.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("衣柜尺寸经过缜密计算，柜体占据53公分，过道49公分，刚好方便走路。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("小窍门：做成开门的衣柜，更节省空间。如果做成移门，轨道需要8公分左右。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/06/img13.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("阳台 4㎡：一个人的休闲区")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("阳台也包含到卧室内，让空间看起来更大了。洗衣、晾衣和休闲娱乐，都可以在这里得到满足。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("小窍门：洗衣机上部分有一些管道，做了柜子即可收纳又可遮挡。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/06/img14.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("餐厅 3.6㎡：卡座式设计更实用")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("餐厅做成卡座式，更能节约空间，同样采用硅藻泥水泥漆做靠背。原木色餐桌可以打开，扩大后能有1.2*0.8米，足够三五朋友聚餐。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/06/img15.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("周琴很喜欢墨绿色，家里无处不在的墨绿。餐厅内更是刷上一整面墨绿，复古又时尚。简单拉根绳，挂几张照片，充满温馨感。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/06/img16.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("唯一的遗憾是灯被工人装错了位置，好在灯是可以上下调节的，所以不会碰头。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("厨房 2.8㎡：挑战史上最小厨房")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("周琴笑称她家有“史上最小的厨房”。长度2.2米，宽度1.18米，煤气灶台面做了55公分，过道还留了63公分，下柜部分全部做了抽屉，比开门好用，收纳力很强大。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/06/img17.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("如果是开门，基本上下柜只能设计2层，但是做抽屉，可以做3层。靠水槽边上，留了一块地方放松下的蒸烤一体机，当微波炉使用。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/06/img18.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("厨房右边的三联动移门叠在一起刚好跟橱柜宽度一致，白色鱼骨砖颜值很高，但是缝隙很大，建议做美缝，否则后期油腻很难打理。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/06/img19.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("卫生间 2㎡：向厨房借面积")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("老榆木台面做的洗手盆，由于空间狭窄，台面厚度只有30厘米，所以做了台上盆＋墙排水＋墙出水，节约空间的同时，台盆下面也看不到难看的污水管，增加收纳空间。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/06/img20.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("书房 8.4㎡：办公收纳两不误")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("这是被保留最完整的一个空间，也是周琴平时待得最多的地方。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/06/img21.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("灰色的墙面，用爱格板仿实木色作为整个台面，视觉高度统一，各种抽屉特别好用。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/06/img22.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("因为没有玄关，鞋子不够放，这面柜子主要用来放包包，鞋子，以及一些杂物的。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/06/img23.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("储物柜：小户型收纳实用方案")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("厨房太迷你，所以冰箱是放过道这里的，比较遗憾的是门洞不一样高，因为上面有结构梁。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/06/img24.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("冰箱周边定制了一组柜子，白色哑光模压材质，拉手用的是比较简洁的黑长拉手。对小户型来说非常实用。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/06/img25.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("看完这个家，你还会觉得小户型不够用吗？窝仔反而觉得小而美，住起来更温馨了。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-502e15f0"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/case6.vue
// module id = 446
// module chunks = 0